import { SideBarMenuItem } from 'src/app/models/side-bar-menu-item';
import { AppRouteEnum } from 'src/app/enums/app-route.enum';
import { UserAccessLevelGroupName } from 'src/app/enums/user-access-level-group-name.enum';

export const practiceAdminEntryMenuItem: SideBarMenuItem = {
  icon: 'settings-2',
  routerLink: AppRouteEnum.PracticeAdmin,
  name: 'Practice Admin',
  accessLevelGroup: UserAccessLevelGroupName.AdminAccessLevelGroup
};
